import { render, staticRenderFns } from "./DDChooseOpportunisticAmount.vue?vue&type=template&id=1c271e91"
import script from "./DDChooseOpportunisticAmount.vue?vue&type=script&lang=js"
export * from "./DDChooseOpportunisticAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports